export default __webpack_public_path__ + "static/media/view_service.72b28809.svg";